import styled, { css } from 'styled-components';

type Props = {
  hover: boolean;
};

export default styled.div<Props>`
  > .container {
    position: relative;

    > .device {
      position: absolute;

      transform: rotate(-10.1deg);
    }

    > .outline {
      /* Directly on top */
      position: absolute;

      top: 0;
      left: 0;

      ${props =>
        props.hover &&
        css`
          opacity: 0;
        `}
    }

    > .device {
      cursor: pointer;
    }

    > .pocket {
      /* Directly on top */
      position: absolute;

      top: 0;
      left: 0;

      /* Allow JS mouse events to "see through" this element */
      pointer-events: none;

      ${props =>
        props.hover
          ? css`
              opacity: 1;
            `
          : css`
              opacity: 0.5;
            `}
    }
  }
`;
